// Auto-refactored from translations.js on 2026-08-19
// Locale: pl

const pl = {
  wieMoeglich: { question: 'Jak to możliwe?', answer: 'Przemyśleliśmy łańcuch wartości na nowo.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Droga STIG ROCK',
    fazit: 'Skrócony łańcuch dostaw eliminuje największe pozycje kosztowe.',
    fazitBigPre: 'To umożliwia rabat do',
    fazitBigValue: '80%',
    steps: [ 'Kopalnia', 'Szlifiernia', 'Certyfikacja', 'Klient końcowy' ]
  },
  nav: { language: 'Język', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Wyjątkowa możliwość',
    subtitle: 'Budowanie majątku zorientowane na przyszłość.',
    description: 'STIG ROCK to międzynarodowa platforma, która oferuje ludziom dostęp do naturalnych diamentów, zrównoważonego budowania majątku oraz wyjątkowej społeczności.',
    scroll: 'Przewiń, aby odkryć'
  },
  disclaimer: {
    overline: 'Nota prawna',
    title: 'Disclaimer',
    paragraphs: [
      'Niniejsza prezentacja służy wyłącznie celom informacyjnym i nie stanowi doradztwa finansowego, inwestycyjnego ani podatkowego.',
      'STIG ROCK nie jest produktem finansowym, lecz odnosi się do diamentów naturalnych jako aktywów rzeczowych.',
      'Nie udziela się gwarancji w odniesieniu do rozwoju wartości, zysków lub dochodów. Wyniki z przeszłości nie stanowią wskazówki dla przyszłych rezultatów.',
      'Wszelkie przedstawione obliczenia związane z prowizjami mają charakter wyłącznie przykładowy i również nie stanowią gwarancji.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'ZBUDOWANA', 'NA STRUKTURZE' ],
    body: 'STIG Group to międzynarodowy koncern oparty na przejrzystości, odpowiedzialności i długoterminowej wartości. Każda marka, każde przedsięwzięcie i każde Partnerstwo kieruje się jednym standardem — bez dróg na skróty, bez wyjątków.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'ZBUDOWANA', 'NA STRUKTURZE' ],
        body: 'STIG Group to międzynarodowy koncern oparty na przejrzystości, odpowiedzialności i długoterminowej wartości. Każda marka, każde przedsięwzięcie i każde Partnerstwo kieruje się jednym standardem — bez dróg na skróty, bez wyjątków.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'ŚWIAT', 'EKSKLUZYWNYCH DIAMENTÓW' ],
        body: 'STIG ROCK to nowoczesna koncepcja STIG Group, łącząca wysokiej klasy diamenty certyfikowane przez GIA z przejrzystymi strukturami i ekskluzywnym doświadczeniem klienta. Jasne plany rozwiązań, profesjonalna obsługa i międzynarodowy zasięg.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'MIĘDZYNARODOWY', 'HANDEL DIAMENTAMI' ],
        body: 'STIG International jest częścią STIG Group i specjalizuje się w międzynarodowym handlu diamentami z certyfikatem GIA. Koncentracja na jakości, zaufaniu i nowoczesnych strukturach handlowych z globalnymi partnerstwami.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'ODPOWIEDZIALNOŚĆ', 'OD SAMEJ KOPALNI' ],
        body: 'Ethical Mines to odpowiedzialne wydobycie, identyfikowalne pochodzenie i diamenty wolne od konfliktów. Od kopalni do rynku — pełna dokumentacja zapewniająca przejrzystość, uczciwość i długoterminową odpowiedzialność w całym łańcuchu dostaw.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamenty',
    stigDrawback: 'Realny magazyn wartości',
    overline: 'Możliwości',
    title: 'Możliwości budowania majątku',
    subtitle: 'Porównanie tradycyjnych ścieżek.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex lub Krypto',
        drawback: 'wysoce spekulacyjne, nieprzewidywalne, złożone'
      },
      {
        tag: 'Akcje',
        name: 'Handel giełdowy',
        drawback: 'ryzyko wahań, wymagana wiedza, nakład czasu'
      },
      {
        tag: 'Krypto',
        name: 'Handel',
        drawback: 'wolatylność, ryzyko regulacyjne, luki w bezpieczeństwie'
      }
    ]
  },
  chance: {
    overline: 'Diamenty',
    title: 'Niedoceniona szansa',
    body: 'Diamenty od lat należą do najbardziej stabilnych i obiecujących form inwestycji, jednak dotychczas tylko nieliczni wykorzystywali ten potencjał.',
    callout: 'Dzięki STIG ROCK po raz pierwszy otwieramy dostęp do tych nadzwyczajnych możliwości dla każdego.'
  },
  wertentwicklung: {
    overline: 'Rozwój wartości 1995 — 2025',
    title: 'Historia o wartości.',
    usd: 'Dolar amerykański',
    usdValue: '-49%',
    diamond: 'Diamenty',
    diamondValue: '+185%',
    note: 'Rozwój od 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Główne powody',
    title: 'Sześć powodów dla diamentów',
    lead: 'Diamenty to realne aktywa rzeczowe, które istnieją niezależnie od walut i systemów finansowych — i od stuleci zachowują swoją wartość.',
    items: [
      {
        n: '01',
        title: 'Stabilność odporna na kryzysy',
        body: 'Gwarancja aktywa rzeczowego. Niezależność od walut i systemów finansowych.'
      },
      {
        n: '02',
        title: 'Ostateczna mobilność',
        body: 'Małe, łatwe do ukrycia i transportu.'
      },
      {
        n: '03',
        title: 'Dywersyfikacja i rzadkość',
        body: 'Wąskie gardła w dostawach i naturalne ograniczenia.'
      },
      { n: '04', title: 'Długoterminowy wzrost', body: '+185% od 1995 roku.' },
      {
        n: '05',
        title: 'Przejrzystość i ekskluzywność',
        body: 'Zasada 4 C jako gwarancja: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Rezerwa rodów królewskich',
        body: 'Nawet domy panujące wykorzystują diamenty jako rezerwę majątkową.'
      }
    ]
  },
  markt: {
    overline: 'Wolumen rynku',
    title: '99 — 108 Mrd. USD',
    sub: 'Wolumen handlu w roku 2025',
    forecast: 'Prognoza do ~2032 / 2034: ok. 140 – 168 Mrd. USD przy umiarkowanym wzroście (~4 – 5 % p.a.).',
    source: 'Źródło: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innowacja',
    title: 'Innowacja. Pierwszy raz na świecie.',
    body: 'STIG ROCK to pierwsza platforma na świecie umożliwiająca generowanie dochodu pasywnego na rynku diamentów, obok wzrostu ich wartości.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Nr rejestru DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'O firmie',
    titleLines: [ 'MIĘDZYNARODOWA', 'STRUKTURA', 'JASNA WIZJA' ],
    body: 'STIG ROCK powstał, aby uczynić rynek diamentów bardziej przejrzystym, nowoczesnym i zorientowanym na klienta — z naciskiem na zaufanie, bezpieczeństwo i długoterminową strukturę.'
  },
  sicherheit: {
    overline: 'Jakość i bezpieczeństwo',
    title: 'Gemological Institute of America',
    body: 'Certyfikowana wiedza ekspercka dla Twoich diamentów. GIA ocenia każdy kamień z najwyższą precyzją i wieloletnim doświadczeniem — wiarygodne ekspertyzy dla naszej firmy i naszych klientów.',
    transparency: 'Każdy diament spełnia najwyższe standardy jakości i jest sprawdzany oraz certyfikowany przez renomowane organizacje. Każdy kamień jest unikalny i posiada indywidualny certyfikat.',
    kimberley: 'Kimberley Process — pracujemy wyłącznie z diamentami wolnymi od konfliktów.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Wyjątkowa innowacja produktowa',
    sub: 'Sześć stopniowanych planów Solution — od $1K do $100K+, każdy z rosnącym rabatem miesięcznym i w całym okresie trwania.',
    recommended: 'Popularne',
    oneYear: '1 rok',
    rowLabels: {
      delivery: 'Czas dostawy',
      price: 'Cena produktu',
      carat: 'Karat',
      monthly: 'Rabat (miesiąc)',
      totalDiscount: 'Rabat (łącznie)',
      duration: 'Okres trwania'
    },
    headers: {
      plan: 'Plan',
      from: 'Od',
      carat: 'Karat',
      monthly: 'Rabat / mies.',
      total: 'Rabat łącznie',
      duration: 'Okres trwania'
    },
    duration: '1 rok',
    footnote: 'Wszystkie ceny są orientacyjne i zależne od jakości, popytu oraz aktualnej sytuacji rynkowej. Plany Solution są możliwe również na okres 2 lat.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + Pakiet VIP',
    title: 'Jeszcze większy rabat z pakietem VIP',
    sub: 'Całkowity rabat na plan – w połączeniu z pakietem VIP otrzymujesz dodatkowo od +1% do +3%, co wyraźnie zwiększa łączny rabat.',
    rowLabels: {
      delivery: 'Czas dostawy',
      price: 'Cena produktu',
      carat: 'Karat',
      monthly: 'Rabat (miesiąc)',
      totalDiscount: 'Rabat (łącznie)',
      vip1: 'Pakiet VIP 1 (+1%)',
      vip2: 'Pakiet VIP 2 (+2%)',
      vip3: 'Pakiet VIP 3 (+3%)'
    },
    footnote: 'Wszystkie ceny są orientacyjne i zależne od jakości, popytu oraz aktualnej sytuacji rynkowej.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Twoje możliwości',
    sub: 'Po upływie planu Solution możesz odsprzedać diamenty nam lub zamówić ich dostawę do domu.',
    options: [
      {
        key: 'deliver',
        title: 'Dostawa',
        body: 'Diamenty (karaty) w cenie Twojego planu DS*'
      },
      {
        key: 'sellToUs',
        title: 'Sprzedaż nam',
        body: 'Możesz odsprzedać nam swoje diamenty po zapłaconej przez Ciebie cenie zakupu.'
      },
      {
        key: 'sellThirdParty',
        title: 'Sprzedaż osobom trzecim',
        body: 'Możesz odsprzedać swoje diamenty osobom trzecim.'
      }
    ],
    footnote: '*Plan DS oznacza plan Solution.'
  },
  tradWeg: {
    overline: 'Tradycyjny handel',
    title: 'Tradycyjna droga',
    sub: 'Zanim diament trafi do klienta końcowego, poprzez handel pośredni, hurtowy i detaliczny powstają znaczne marże w porównaniu do ceny surowego diamentu z kopalni.',
    steps: [
      { title: 'Kopalnia', subtitle: 'Surowe diamenty' },
      { title: 'Pośrednik', subtitle: 'Zakup surowych diamentów' },
      { title: 'Szlifiernia', subtitle: 'Szlifowanie diamentów jubilerskich' },
      { title: 'Certyfikacja', subtitle: 'przez uznane instytuty jak GIA' },
      { title: 'Giełda diamentów', subtitle: 'Sprzedaż do hurtu' },
      { title: 'Hurtownia', subtitle: 'Sprzedaż do detalisty' },
      { title: 'Detal', subtitle: 'np. jubilerzy' },
      { title: 'Klient końcowy', subtitle: 'Zakup diamentów' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'Droga STIG ROCK',
    sub: 'Przełamujemy ten cykl, kupując surowe diamenty bezpośrednio z kopalni, zlecając ich szlifowanie i certyfikację naszym partnerom. Dzięki temu możemy przekazywać marże handlowe naszym klientom w formie naliczeń rabatowych.',
    duration: '12 miesięcy – czas trwania planu DS',
    centerBig: '04',
    centerCaption: 'Do 4 cykli handlowych podczas trwania planu DS',
    cycle: [
      { n: '1.', title: 'Zakup surowych diamentów', body: 'dla planu DS' },
      { n: '2.', title: 'Szlifowanie i certyfikacja', body: 'przez naszych partnerów' },
      { n: '3.', title: 'Sprzedaż klientom', body: 'i hurtownikom' },
      { n: '4.', title: 'Powtarzamy ten proces', body: 'do 4× w roku' }
    ],
    steps: [
      { title: 'Kopalnia', subtitle: 'Surowe diamenty' },
      { title: 'Szlifiernia', subtitle: 'przez naszych partnerów' },
      { title: 'Certyfikacja', subtitle: 'przez uznane instytuty' },
      { title: 'Klient końcowy', subtitle: 'Zakup i naliczenia rabatowe' }
    ],
    footnote: '*Plan DS oznacza plan Solution.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Pakiety VIP',
    sub: 'Ważne przez 12 miesięcy na wszystkie wykupione przez Ciebie plany Solution. W zależności od pakietu VIP: +1% do +3% dodatkowego rabatu',
    cardKicker: 'dodatkowo – na wszystkie',
    cardKicker2: 'plany Solution',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Rabaty stają się oszczędnościami',
      body: 'Miesięczne oszczędności zamiast miesięcznych obciążeń. Z rabatów powstają oszczędności – a one opłacają dokładnie te rzeczy, za które normalnie płacisz co miesiąc z własnej kieszeni.',
      line1Label: 'Plan DS od',
      line1Value: '$5.000',
      line2Label: 'mies. rabat',
      line2Value: '3%',
      line3Label: 'Pakiet VIP 3',
      line3Value: '+3%',
      resultLabel: 'mies. oszczędności',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Jak to możliwe?',
    title: 'Na nowo przemyśleliśmy łańcuch wartości.',
    traditionalTitle: 'Tradycyjna droga',
    traditionalSteps: [
      'Kopalnia — surowe diamenty',
      'Pośrednik — zakup',
      'Szlifiernia — szlif',
      'Certyfikacja (GIA)',
      'Giełda diamentów — hurt',
      'Hurtownia → Detal',
      'Jubilerzy → Klient końcowy'
    ],
    traditionalNote: 'Zanim diament trafi do klienta końcowego, poprzez handel pośredni, hurtowy i detaliczny powstają znaczne marże.',
    stigTitle: 'Droga STIG ROCK',
    stigSteps: [
      'Bezpośredni zakup — surowe diamenty z kopalni',
      'Szlifowanie i certyfikacja przez naszych partnerów',
      'Sprzedaż klientom końcowym i klientom B2B',
      'Do 4 cykli handlowych rocznie'
    ],
    stigNote: 'Przełamujemy ten cykl i przekazujemy marże handlowe naszym klientom w formie naliczeń rabatowych — do 4 cykli handlowych podczas trwania planu DS.'
  },
  optionen: {
    overline: 'Twoje możliwości',
    title: 'Po upływie planu Solution',
    items: [
      { title: 'Dostawa', body: 'Diamenty (karaty) w cenie Twojego planu DS.' },
      {
        title: 'Sprzedaż nam',
        body: 'Odsprzedaż po zapłaconej przez Ciebie cenie zakupu.'
      },
      { title: 'Sprzedaż osobom trzecim', body: 'Zbycie diamentów na wolnym rynku.' }
    ]
  },
  einfacherWeg: {
    overline: 'Plany Solution — wyjątkowa innowacja produktowa',
    title: 'Prosta droga',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Rejestracja',
        body: 'Skontaktuj się z osobą polecającą i utwórz bezpłatne konto!'
      },
      { n: '02', icon: 'cart', title: 'Zakup produktu', body: 'Już od $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Otrzymywanie rabatów',
        body: 'Otrzymuj miesięczne naliczenia rabatowe.'
      }
    ]
  },
  business: {
    overline: 'Rodzaje bonusów',
    title: 'Najprostsza i najuczciwsza droga.',
    sub: 'Pięć rodzajów bonusów — dla Twojego udanego budowania biznesu.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Do poziomu 3, od stopnia kariery Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Od Sapphire — nieskończenie głęboko.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Od Infinity Bonus – do poziomu 5 · BEZ kwalifikacji.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pule z obrotu światowego.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Jednorazowy bonus w diamentach (karatach).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Ten bonus jest wypłacany za każdy nowo wykupiony plan Solution do 3. poziomu. Poszczególne poziomy odblokowujesz przy bardzo niewielkich kwalifikacjach.',
    total: 'Do 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'od samego początku',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'od stopnia kariery Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'od stopnia kariery Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Od stopnia kariery Sapphire kwalifikujesz się do naszego planu Infinity Bonus. Otrzymujesz 3% bonusu. Z każdym nowym stopniem kariery dochodzą kolejne procenty. Jeśli Partner w Twoim zespole również posiada kwalifikację, otrzymujesz różnicę między rangami.',
    exampleTitle: 'Przykład',
    exampleRows: [
      { label: 'Jesteś Blue Diamond', value: '12%' },
      { label: 'Twój Partner jest Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Twój Infinity Bonus', value: '9%' },
    totalNote: 'Łącznie do 24% Infinity Bonus na wszystkie wykupione plany Solution w Twoim zespole — nieskończenie głęboko.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Dzięki temu bonusowi zyskujesz na sukcesie swojego zespołu. Otrzymujesz Matching Bonus w wysokości 5% od Infinity Bonus Twoich Partnerów — aż do 5. poziomu Twojego zespołu.',
    note: 'Na wszystkie wypłaty Infinity Bonus w Twoim zespole – do 5. poziomu. Od samego początku – BEZ kwalifikacji.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Łącznie do',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% światowego obrotu trafia w równych częściach do 3 różnych pul. Osiągając określone stopnie kariery, kwalifikujesz się do każdej poszczególnej puli.',
    forever: 'Raz osiągnięte – udział na ZAWSZE!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'od Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'od Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'od Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Łącznie',
    totalValue: '3%',
    totalSuffix: 'światowego obrotu'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Od stopnia kariery Diamond otrzymujesz Rang Bonus. Jest on wypłacany w diamentach (karatach). Jest to bonus jednorazowy.',
    highlight: 'Diamenty (karaty) o łącznej wartości',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Stopnie kariery',
    title: 'Stopnie kariery',
    sub: 'Do osiągnięcia poszczególnych stopni kariery liczy się historyczny obrót całkowity (HG). Od poziomu Sapphire musi być on rozdzielony na kilka zespołów. Aby osiągnąć Ruby lub wyższy poziom, potrzebujesz co najmniej dwóch bezpośrednich Partnerów z planem Solution.',
    forever: 'Raz osiągnięte – potwierdzone na ZAWSZE!',
    footnote: 'HV = Historyczny obrót całkowity.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Wystartuj z nami',
    title: 'Właściwy czas jest właśnie teraz.',
    body: 'Ten model biznesowy wyznacza nowe standardy i łączy wszystkie czynniki sukcesu dla długoterminowego, zrównoważonego i udanego biznesu. Zarejestruj się już dziś, wybierz swój plan Solution i wykorzystaj tę wyjątkową szansę biznesową.',
    hint: 'Porozmawiaj z osobą, która zaprosiła Cię na tę prezentację — ma ona dla Ciebie link do rejestracji.',
    formName: 'Imię',
    formEmail: 'E-mail',
    formPhone: 'Telefon',
    formSubmit: 'Nawiąż kontakt',
    success: 'Dziękujemy — skontaktujemy się dyskretnie i osobiście.',
    callCta: 'Zadzwoń',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Nota prawna & Disclaimer',
    disclaimer: 'Niniejsza prezentacja służy wyłącznie celom informacyjnym i nie stanowi doradztwa finansowego, inwestycyjnego ani podatkowego. STIG ROCK nie jest produktem finansowym, lecz odnosi się do diamentów naturalnych jako aktywów rzeczowych. Nie udziela się gwarancji w odniesieniu do rozwoju wartości, zysków lub dochodów. Wyniki z przeszłości nie stanowią wskazówki dla przyszłych rezultatów. Wszelkie przedstawione obliczenia związane z prowizjami mają charakter wyłącznie przykładowy i również nie stanowią gwarancji. Zastrzega się prawo do zmian treści — wolne tłumaczenie (nieoficjalne).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Wszelkie prawa zastrzeżone.',
    version: 'Wersja: DS-12-2025 V3'
  },
  misc: { next: 'Następna sekcja' }
};

export default pl;
